const template = ({listClass, placeId, mainText, secondaryText, secTextClass, mainTextClass}) => {
    return `
    <li class='${listClass}' data-place-id='${placeId}'>
        <span class='${mainTextClass}'>${mainText}</span>
        <span class='${secTextClass}'>${secondaryText}</span>
    </li>`;
};

const parsePlace = (place) => Odigeo._.assign({}, place, {
    mainText: place.mainText.replace(/,/g, ''),
    secondaryText: (place.secondaryText) ? `,&nbsp;${place.secondaryText}` : '',
    listClass: 'od-places-suggestion-list-item odf-space-inner-top-m odf-space-inner-bottom-m ' +
        'odf-text-mono-color-02 odf-text-s odf-stroke-primary get_place_id',
    mainTextClass: 'od-places-suggestion-subcomp',
    secTextClass: 'odf-strong od-places-suggestion-subcomp od-elipsis',
});

const AUTOCOMPLETE_LIST_ITEM_CLASS = 'od-places-suggestion places_suggestion odf-space-inner-left-s ' +
    'odf-space-inner-right-s';

module.exports = {
    init: function(mainContainerSelector) {
        this.mainContainerSelector = mainContainerSelector
            ? document.querySelector(mainContainerSelector)
            : null;
        if (this.mainContainerSelector) {
            this.streetNumber = '';
            this.streetName = '';
            this.createListContainer = this.createListContainer.bind(this);
            this.removeListContainer = this.removeListContainer.bind(this);
            this.populateForm = this.populateForm.bind(this);
            this.fillSuggestionList = this.fillSuggestionList.bind(this);
            this.focusAndFillField = this.focusAndFillField.bind(this);
            this.populateFormByType = this.populateFormByType.bind(this);
            this.createListContainer();
            return this;
        }
    },
    fillSuggestionList: function(response) {
        let html = '';
        const data = response.changed.predictionsList || response.attributes.predictionsList || null;

        if (data && data.length > 0) {
            html = Odigeo._.reduce(data, (html, place) => html + template(parsePlace(place)), '');
            if (!this.suggestionsContainer) {
                this.createListContainer();
            }
            this.suggestionsContainer.innerHTML = html;
            this.suggestionsContainer.className = AUTOCOMPLETE_LIST_ITEM_CLASS;
        } else {
            this.removeListContainer();
        }
    },
    populateForm: function(response) {
        if (response.changed.addressComponents) {
            const data = response.changed.addressComponents;
            for (let i=0; i < data.length; i++) {
                const type = response.changed.addressComponents[i].types[0];
                const value = response.changed.addressComponents[i].longName;
                const country = response.changed.addressComponents[i].shortName;
                this.populateFormByType(type, value, country);
            }
            this.removeListContainer();
        } else {
            if (this.suggestionsContainer) {
                this.removeListContainer();
            }
        }
    },
    populateFormByType: function(type, val, country) {
        const STREET_NUMBER = 'STREET_NUMBER';
        const LOCALITY = 'LOCALITY';
        const ROUTE = 'ROUTE';
        const POSTAL_CODE = 'POSTAL_CODE';
        const COUNTRY = 'COUNTRY';
        let street = '';

        switch (type) {
            case ROUTE:
                this.streetName = val;
                street = (!this.streetNumber) ? `${this.streetName}` :
                    `${this.streetName} ${this.streetNumber}`;
                this.focusAndFillField('[data-name="address"]', street);
                break;
            case STREET_NUMBER:
                this.streetNumber = val;
                break;
            case LOCALITY:
                this.focusAndFillField('[data-name="cityName"]', val);
                break;
            case POSTAL_CODE:
                this.focusAndFillField('[data-name="zipCode"]', val);
                break;
            case COUNTRY:
                this.fillCountry(country);
                break;
            default:
                break;
        }
    },
    fillCountry: function(country) {
        const nodeList = document.querySelectorAll('[data-name="country"] option');
        const countriesArray = Array.prototype.slice.call(nodeList);
        for (let i = 0; i < countriesArray.length; i++) {
            countriesArray[i].selected = false;
            if (countriesArray[i].value === country) {
                countriesArray[i].selected = true;
            }
        }
    },
    createListContainer: function() {
        if (!document.querySelector('.places_suggestion')) {
            this.suggestionsContainer = document.createElement('ul');

            this.suggestionsContainer.className = `${AUTOCOMPLETE_LIST_ITEM_CLASS} odf-hidden`;
            this.mainContainerSelector.appendChild(this.suggestionsContainer,
                this.mainContainerSelector);
        }
    },
    removeListContainer: function() {
        if (this.suggestionsContainer) {
            this.suggestionsContainer.remove();
            this.suggestionsContainer = null;
        }
    },
    focusAndFillField: function(selector, value) {
        if (!selector || !value) return false;
        const elm = document.querySelector(selector);
        elm.value = value;
        if (elm.parentNode.parentNode.className.indexOf(' valid') === -1) {
            elm.parentNode.parentNode.className += ' valid';
        }
        elm.blur();
    },
};


